import React from 'react';
import { Users, IndianRupee, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { vehicles, companyInfo } from '../mockData';

const VehiclesSection = () => {
  const handleBookNow = (vehicleName) => {
    const message = `Hi, I want to book ${vehicleName}`;
    window.open(`https://wa.me/91${companyInfo.phone[0]}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="vehicles" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-orange-600">Fleet</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Choose from our wide range of well-maintained vehicles for a comfortable journey
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {vehicles.map((vehicle) => (
            <div
              key={vehicle.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-orange-200 transform hover:-translate-y-2"
            >
              {/* Vehicle Image */}
              <div className="relative h-56 overflow-hidden bg-gray-100">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-orange-600 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                  {vehicle.seating}
                </div>
              </div>

              {/* Vehicle Details */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>

                {/* Rate */}
                <div className="flex items-center gap-2 mb-4">
                  <IndianRupee className="w-5 h-5 text-orange-600" />
                  <span className="text-2xl font-bold text-orange-600">{vehicle.ratePerKm}</span>
                  <span className="text-gray-600">/ km</span>
                </div>

                {/* Features */}
                <div className="space-y-2 mb-6">
                  {vehicle.features.map((feature, index) => (
                    <div key={index} className="flex items-center text-sm text-gray-700">
                      <span className="w-2 h-2 bg-orange-600 rounded-full mr-2"></span>
                      {feature}
                    </div>
                  ))}
                </div>

                {/* Book Now Button */}
                <Button
                  onClick={() => handleBookNow(vehicle.name)}
                  className="w-full bg-orange-600 hover:bg-orange-700 text-white py-6 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Book Now
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VehiclesSection;
